import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocaleId } from '../models/locale.model';
import { ReportRecord } from '../models/report.model';
import { CustomDataRetriever } from './custom-data-retriever.abstract';

interface MinViewResponse {
  [recordId: number]: {
    [fieldId: number]: number;
  };
}

@Injectable()
export class MinLeasedTermService extends CustomDataRetriever {
  constructor(private http: HttpClient) {
    super();
  }

  getCustomData(
    reportId: number,
    templateId: number,
    locale: LocaleId,
    payload: any,
    record: ReportRecord
  ): Observable<string> {
    const minLeasedTerm$ = this.getMinLeasedTerm(reportId, templateId, locale, payload);
    return minLeasedTerm$.pipe(map(minLeasedTerm => this.mapMinLeasedTermData(minLeasedTerm, record, payload)));
  }

  getMinLeasedTerm(reportId: number, templateId: number, locale: LocaleId, payload: any): Observable<MinViewResponse> {
    const uri = `/api/reports/${reportId}/customdata?type=minLeased`;
    const templateIdParam = `templateID=${templateId}`;
    const viewParam = `view=min`;
    const localeParam = `locale=${locale}`;

    const finalUri = `${uri}&${templateIdParam}&${viewParam}&${localeParam}`;
    return this.cachedCustomData(finalUri, this.http.post.bind(this.http, finalUri, payload));
  }

  mapMinLeasedTermData(minLeasedTerm: MinViewResponse, record: ReportRecord, payload: number[]): string {
    if (minLeasedTerm == null) {
      return '';
    }
    const { edpRecordId } = record;
    const currentRecordMinLeased = minLeasedTerm[edpRecordId] || {};
    /*
     * NOTE (edmundo): I'm forcing to only use the first element of the payload,
     * as that is the current requirement for EMEA 5
     */
    const values = currentRecordMinLeased[payload[0]];
    return values == null ? '' : values.toString();
  }
}
